// frontend/modules/internal-account/index.ts
import { ModuleConfig } from '@/core/module';
import { internalAccountRoutes } from './routes';
import { useInternalAccountStore } from './stores/internal-account-store';

export const InternalAccountModule: ModuleConfig = {
    name: 'internal-account',
    routes: internalAccountRoutes,
    stores: {
        internalAccount: useInternalAccountStore
    },
    initialize: () => {
        console.log('Internal Account module initialized');
    }
};
